import { FormControl, Validators, ValidatorFn } from '@angular/forms';
import { CultureInfo } from '../core/culture-info';
import { FileFormArray } from './file-form-array';

export class LanguageControl extends FormControl {
    private static readonly duplicateLanguageError = 'duplicateLanguage';

    constructor(fileFormArray: FileFormArray, isRequired = true) {
        super(
            null,
            isRequired
            ? [Validators.required, LanguageControl.duplicateLanguageValidator(fileFormArray)]
            : []);
    }

    public get hasLanguageDuplicateError(): boolean {
        return this.hasError(LanguageControl.duplicateLanguageError);
    }

    public get hasRequiredError(): boolean {
        return this.hasError('required');
    }

    private static duplicateLanguageValidator(fileControls: FileFormArray): ValidatorFn {
        return (currentLanguageControl: FormControl) => {
            const currentLanguage = currentLanguageControl.value as CultureInfo;

            if (!currentLanguage) {
                return null;
            }
            
            for (let control of fileControls.fileFormGroups) {
                if (control.languageControl === currentLanguageControl) {
                    continue;
                }

                const language = control.languageControl.value as CultureInfo;

                if (!language) {
                    continue;
                }

                if (language.languageRowId === currentLanguage.languageRowId) {
                    return { [this.duplicateLanguageError]: true };
                }
            }

            return null;
        };
    }
}